// extracted by mini-css-extract-plugin
module.exports = {"publish":"Publish_style_publish__12Y0K","uploadVideo":"Publish_style_uploadVideo__2Urtx","uploadImage":"Publish_style_uploadImage__hZjiw","input":"Publish_style_input__19lTQ"};